import { staticPath } from "mypage/src/lib/$path";
import React from "react";
import styled from "styled-components";
import Image from "~/components/atoms/Image";
import { colorPrimary } from "~/lib/constants";
import {
  getArticleEvaluationDisplayName,
  QaArticleEvaluation,
} from "~/models/questionAnswer/articleEvaluation";
import { unstyledButton } from "~/styles/CommonStyles";

interface Props {
  onClickComment: () => void;
  onClickEvaluation: (props: {
    evaluationType: QaArticleEvaluation["type"];
  }) => void;
  showEvaluation?: boolean;
}

const CommentAndEvaluation: React.VFC<Props> = ({
  onClickComment,
  onClickEvaluation,
  showEvaluation,
}) => {
  return (
    <>
      <ReviewButtonRow>
        <CommentTriggerButton
          type="button"
          onClick={onClickComment}
          onTouchEnd={onClickComment}
        >
          <Image
            src={staticPath.img.icon_comment_white_svg}
            alt="icon comment"
            height={28}
            width={28}
            disableHover
          />
          <CommentTriggerText>コメントする</CommentTriggerText>
        </CommentTriggerButton>
        {showEvaluation && (
          <EvaluationButton
            onTouchEnd={() =>
              onClickEvaluation({ evaluationType: "convincing" })
            }
            onClick={() => onClickEvaluation({ evaluationType: "convincing" })}
          >
            <Image
              src={staticPath.img.icon_light_svg}
              alt="icon light"
              height={28}
              width={28}
              disableHover
            />
            <EvaluationText>
              {getArticleEvaluationDisplayName("convincing")}
            </EvaluationText>
          </EvaluationButton>
        )}
      </ReviewButtonRow>

      {showEvaluation && (
        <ReviewButtonRow>
          <EvaluationButton
            onTouchEnd={() =>
              onClickEvaluation({ evaluationType: "informative" })
            }
            onClick={() => onClickEvaluation({ evaluationType: "informative" })}
          >
            <Image
              src={staticPath.img.icon_study_svg}
              alt="icon study"
              height={28}
              width={28}
              disableHover
            />
            <EvaluationText>
              {getArticleEvaluationDisplayName("informative")}
            </EvaluationText>
          </EvaluationButton>
          <EvaluationButton
            onTouchEnd={() =>
              onClickEvaluation({ evaluationType: "easyToUnderstand" })
            }
            onClick={() =>
              onClickEvaluation({ evaluationType: "easyToUnderstand" })
            }
          >
            <Image
              src={staticPath.img.icon_thumbsup_outline_svg}
              alt="icon thumbsup"
              height={28}
              width={28}
              disableHover
            />
            <EvaluationText>
              {getArticleEvaluationDisplayName("easyToUnderstand")}
            </EvaluationText>
          </EvaluationButton>
          <EvaluationButton
            onTouchEnd={() =>
              onClickEvaluation({ evaluationType: "hardToUnderstand" })
            }
            onClick={() =>
              onClickEvaluation({ evaluationType: "hardToUnderstand" })
            }
          >
            <Image
              src={staticPath.img.icon_thumbsdown_outline_svg}
              alt="icon thumbsdown"
              height={28}
              width={28}
              disableHover
            />
            <EvaluationText>
              {getArticleEvaluationDisplayName("hardToUnderstand")}
            </EvaluationText>
          </EvaluationButton>
        </ReviewButtonRow>
      )}
    </>
  );
};

const ReviewButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  & + & {
    margin-top: 16px;
  }
`;

const CommentTriggerButton = styled.button`
  ${unstyledButton}

  align-items: center;
  background-color: ${colorPrimary[500]};
  border-radius: 8px;
  border: 1px solid ${colorPrimary[500]};
  color: #fff;
  display: flex;
  font-size: 20px;
  font-weight: bold;
  grid-column-gap: 12px;
  height: 60px;
  justify-content: center;
  line-height: 34px;
  width: 214px;

  &:hover {
    background-color: ${colorPrimary[600]};
  }
`;

const CommentTriggerText = styled.div``;

const EvaluationButton = styled.button`
  ${unstyledButton}

  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid ${colorPrimary[500]};
  color: ${colorPrimary[500]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  height: 60px;
  width: 98px;
`;

const EvaluationText = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
`;

export default CommentAndEvaluation;
